/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_preset_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will it make a sound when the time is up?`)
};

const es_timer_preset_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Sonará cuando se acabe el tiempo?`)
};

const de_timer_preset_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ertönt ein Ton, wenn die Zeit abgelaufen ist?`)
};

const nl_timer_preset_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maakt hij geluid als de tijd om is?`)
};

const fr_timer_preset_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fera-t-il un son quand le temps sera écoulé ?`)
};

const it_timer_preset_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farà un suono quando il tempo è scaduto?`)
};

const pt_br2_timer_preset_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele vai emitir um som quando o tempo acabar?`)
};

const pt_timer_preset_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai emitir um som quando o tempo terminar?`)
};

const ja_timer_preset_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間になったら音が鳴りますか？`)
};

const zh_timer_preset_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间到时会发出提示音吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_preset_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_preset_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_preset_faq2_q", locale)
	if (locale === "en") return en_timer_preset_faq2_q(inputs)
	if (locale === "es") return es_timer_preset_faq2_q(inputs)
	if (locale === "de") return de_timer_preset_faq2_q(inputs)
	if (locale === "nl") return nl_timer_preset_faq2_q(inputs)
	if (locale === "fr") return fr_timer_preset_faq2_q(inputs)
	if (locale === "it") return it_timer_preset_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_preset_faq2_q(inputs)
	if (locale === "pt") return pt_timer_preset_faq2_q(inputs)
	if (locale === "ja") return ja_timer_preset_faq2_q(inputs)
	return zh_timer_preset_faq2_q(inputs)
};